<template>
  <div id="ClockRecord">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            差勤紀錄
          </div>
          <div class="tip">
            檢視差勤紀錄
          </div>
        </div>
      </div>
      <RecordFilter
        ref="RecordFilter"
        :search="handleSearch"
      />
      <div class="title_bar center">
        <div class="left">
          <span
            v-if="warningText"
            class="warning-text"
          > {{ warningText }}</span>
        </div>
        <div class="right">
          <span>搜尋結果共計 {{ total }} 筆</span>
          <el-button
            :disabled="total == 0"
            icon="icon-output"
            round
            @click="exportExcel"
          >
            匯出
          </el-button>
        </div>
      </div>
      <el-table
        :data="listData"
        ety-text="目前無打卡紀錄"
        tooltip-effect="dark"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          prop="ManagerName"
          label="姓名"
          min-width="80"
        />
        <el-table-column
          prop="ManagerJob"
          label="職務"
          min-width="80"
        />
        <el-table-column
          prop="ManagerShifts"
          label="班別"
          min-width="80"
        />
        <el-table-column
          prop="ClockInTime"
          label="上班時間"
          min-width="130"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.ClockInTime">
              <span>{{ scope.row.ClockInTime }}</span>
              <i
                v-if="scope.row.ClockInImg"
                class="icon-images"
                aria-hidden="true"
                @click="() => openSnapshotDialog(scope.row.ClockInImg)"
              />
            </div>
            <div
              v-else
              class="warning-text"
            >
              無資料
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ClockOutTime"
          label="下班時間"
          min-width="130"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.ClockOutTime">
              <span>{{ scope.row.ClockOutTime }}</span>
              <i
                v-if="scope.row.ClockOutImg"
                class="icon-images"
                aria-hidden="true"
                @click="() => openSnapshotDialog(scope.row.ClockOutImg, true)"
              />
            </div>
            <div
              v-else
              class="warning-text"
            >
              無資料
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="Note"
          label="值勤紀錄"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <i
              v-if="scope.row.isNewVersion"
              class="icon-note"
              :style="( !!scope.row.ClockInRemark || !!scope.row.ClockOutRemark ) && { color: '#49a46b' }"
              @click="() => openNoteDialog(scope.$index)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="ManagerShifts"
          label="差勤狀態"
          min-width="80"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.AbnormalNote"
              :content="scope.row.AbnormalNote"
              effect="dark"
              placement="top"
            >
              <span :class="scope.row.ClockStatusName == '待審核' ? '': 'status_red'">{{ scope.row.ClockStatusName }}</span>
            </el-tooltip>
            <span
              v-else
              class="status_green"
            >{{ scope.row.ClockStatusName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="WorkTime"
          label="工時"
          min-width="80"
        >
          <template slot-scope="scope">
            <el-tooltip
              content="時：分"
              effect="dark"
              placement="top"
            >
              <span>{{ scope.row.WorkingTime }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
    <RecordRemarkDialog
      ref="RecordRemarkDialog"
      :remark-update="updateRemarkInIndex"
    />
    <RecordSnapshotDialog ref="RecordSnapshotDialog" />
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import RecordFilter from './components/RecordFilter.vue'
import RecordRemarkDialog from './components/RecordRemarkDialog.vue'
import RecordSnapshotDialog from './components/RecordSnapshotDialog.vue'

import { debounce } from 'lodash'

export default {
  components: {
    RecordFilter,
    RecordRemarkDialog,
    RecordSnapshotDialog,
    TableLoading
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      axios(`${process.env.VUE_APP_CORE_URL}/api/Auth/UserInfo`, {
        method: 'GET',
        headers: {
          kingnetauth: `Cookies ${vm.$getCookie('comLoginToken').replace('token=', '')}`
        }
      }).then((res) => {
        console.log(res.data.Data)
        if (res.data.Data.IsAuthorizationAccount === false) {
          vm.$alert('您無權限操作此功能，請使用手機帳號重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            vm.$toMainPage()
            return false
          })
        } else {
          next()
        }
      }).catch(() => {})
    })
  },
  data () {
    return {
      total: 0,
      option: {
        date: [],
        name: '',
        status: [] // checkbox有兩個，因此改使用array存而非boolean
      },
      isNeedExport: false,
      listData: [],
      page: 1,
      maxCount: 10, // * 常數 這個值不會變
      loading: false,
      isAccess: false,
      isDisplayTime: false
    }
  },
  computed: {
    warningText () {
      if (this.isAccess && this.isDisplayTime) {
        return ''
      } else if (this.isAccess && !this.isDisplayTime) {
        return this.$t('AttendanceRecord.OnlyDateWarning')
      } else {
        return this.$t('AttendanceRecord.OnlyApplyWarning')
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.listenerTask)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerTask)
  },
  methods: {
    listenerTask () {
      if (getScrollHeight() - (getScrollTop() + getClientHeight()) < 5) { this.handleScrollAutoUpdate() }
    },
    openSnapshotDialog (url, isClockOut) {
      this.$refs.RecordSnapshotDialog.openDialog(url, isClockOut)
    },
    openNoteDialog (ind) {
      const { ClockId, ClockInRemark, ClockOutRemark, DutyRecordNote, HandoverMattersNote, ClockOutTime } = this.listData[ind]
      const isClockOut = !!ClockOutTime // * 下班沒
      this.$refs.RecordRemarkDialog.openDialog({
        remarkId: ClockId,
        inRemark: ClockInRemark,
        outRemark: ClockOutRemark,
        dutyRecord: DutyRecordNote,
        handover: HandoverMattersNote,
        dataIndex: ind,
        isClockOut
      })
    },
    exportExcel: debounce(async function () {
      // * 設定下一次搜尋時附帶匯出功能
      this.isNeedExport = true
      // * 觸發 search
      this.$refs.RecordFilter.filterActive()
    }, 500),
    updateRemarkInIndex (ClockInRemark, ClockOutRemark, DutyRecordNote, HandoverMattersNote, ind) {
      this.listData[ind] = {
        ...this.listData[ind],
        ClockInRemark,
        ClockOutRemark,
        DutyRecordNote,
        HandoverMattersNote
      }
    },
    // * 上滑載入更多與篩選搜尋都統一使用這個前置處理
    getRecordListApi ({ offset, maxCount = 10, date = [], name, status = [] }) {
      const params = {
        Offset: offset,
        MaxCount: maxCount,
        'Filter.ManagerName': name,
        'Filter.DateAt.StartAt': date[0],
        'Filter.DateAt.DueAt': date[1],
        'Filter.NoClockOut': status.includes('未打卡下班'),
        'Filter.NoClockIn': status.includes('未打卡上班')
      }
      return apiAttendanceManagement.Record.GetClockList(params)
        .then(res => {
          this.isAccess = res.data.Data.IsAccess
          this.isDisplayTime = res.data.Data.IsDisplayTime
          return [transRecordListApiFormat(res.data.Data), null]
        })
        .catch(_ => [null, '這裡的錯誤可以以後再處理'])
    },
    handleSearch: debounce(async function (option) {
      this.listData = []
      this.loading = true
      let params = {}
      if (option) {
        // * 處理 filter 那邊的回傳
        params = {
          ...option,
          date: option && option.date ? option.date : [],
          status: option.status,
          offset: 0
        }
        this.option = params
        // * filter Search Submit 專用這邊
      } else {
        params = { offset: 0, maxCount: 10, date: [], name: '', status: [] }
        this.option = params
      }
      const [recordList] = await this.getRecordListApi(params)

      await this.$sleep(1000)
      // * 轉換 API 資料為前端使用資料格式
      if (recordList) {
        // * 篩選列表結果會直接全部覆蓋既有值, 並保存設定以備下滑更新使用
        this.total = recordList.Total
        this.page = 1
        this.listData = recordList.ManagerClocks
        if (getScrollHeight() > 864) { this.handleScrollAutoUpdate() }
      } else {
        this.$message({
          message: '發生未知錯誤，請稍後再試',
          type: 'error'
        })
      }

      // * 判斷是否需要一併匯出
      if (this.isNeedExport) {
        this.isNeedExport = false
        if (recordList) {
          if (this.total) {
            this.handleExportApi(this.option)
          } else {
            this.$message({
              message: '目前符合條件的資料筆數為 0 筆，請重新選擇資料匯出的條件',
              type: 'error'
            })
          }
        } else {
          this.$message({
            message: '差勤 Excel 報表匯出失敗',
            type: 'error'
          })
        }
      }
      this.loading = false
    }, 500),
    async handleExportApi ({ date = [], name, status = false }) {
      if (date.length === 0) {
        this.$alert('您未選擇匯出資料的時間區間，請使用【資料篩選】選擇匯出時間的起訖日。系統一次匯出資料量的時間區間最大限制為三個月，如需匯出超過三個月，建議您多次分批匯出即可', '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {}
        })
        return
      }
      // * API 只支援 3 個月區間的資料 ( 有填時間的話 )
      const [checkTimeStart, checkTimeEnd] = date
      console.log([checkTimeStart, checkTimeEnd])

      if (checkTimeStart && checkTimeEnd) {
        const gap = new Date(checkTimeEnd) - new Date(checkTimeStart)
        if (gap > 3 * 30 * 24 * 60 * 60 * 1000) {
          this.$alert('系統一次顯示資料量最大限制為三個月，如需顯示超過三個月，建議您多次分批顯示即可', '錯誤', {
            confirmButtonText: '確定',
            type: 'error',
            callback: action => {}
          })
          return
        }
      }
      const params = {
        ManagerName: name,
        'DateAt.StartAt': date[0],
        'DateAt.DueAt': date[1],
        NoClockOut: status.includes('未打卡下班'),
        NoClockIn: status.includes('未打卡上班')
      }

      const [excelDownloadObject] = await apiAttendanceManagement.Record.GetClockListExcel(params, { responseType: 'blob' })
        .then(res => [{ url: window.URL.createObjectURL(new Blob([res.data])), name: getHeaderFileName(res.headers) }, null])
        .catch(_ => [null, '錯誤以後處理'])

      if (excelDownloadObject) {
        const { url, name: fileName } = excelDownloadObject
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } else {
        this.$message({
          message: '差勤 Excel 報表匯出失敗',
          type: 'error'
        })
      }
    },
    async handleScrollAutoUpdate () {
      // * 滑動更新之前 需檢查資料是否超過上限
      if (this.loading || this.listData.length >= this.total) {
        return
      }
      this.loading = true
      // * 進行滑動更新
      const [recordList] = await this.getRecordListApi({
        ...this.option,
        date: this.option.date ? this.option.date : [],
        offset: this.page * this.maxCount
      })
      await this.$sleep(1000)
      this.listData = this.listData.concat(recordList.ManagerClocks)
      // * 取得資料結束 會需要更新 page
      this.page++
      this.loading = false
      /**
       * 資料加載後列表元素變多, 頁面會被往下方推移, 滾軸會需要保持原本的位置,
       * 很多頁面都是用減去的方式, 會產生滑動體驗中斷的情形
       */
      const prevScrollPosition = getScrollTop()
      this.$nextTick(() => {
        document.documentElement.scrollTop = prevScrollPosition
      })
    }
  }
}

function getHeaderFileName (responseHeader) {
  const disposition = responseHeader['content-disposition']
  const [, fileString] = disposition.split(';')
  const [, fileName] = fileString.split('=')
  return decodeURIComponent(fileName.replace('______________', '智生活差勤紀錄'))
}

// API 格式防腐層, 後端想怎麼改就怎麼改, 只要調整這區就好 :D
function transRecordListApiFormat (recordObject) {
  return {
    ...recordObject,
    ManagerClocks: recordObject.ManagerClocks.map(record => {
      const isNewVersion = !!(record.Contents && record.Contents.length)
      const { Note: ClockInRemark = '' } = record.Contents.find(remark => remark.ClockType === 1) || {} // * 上班備註
      const { Note: ClockOutRemark = '' } = record.Contents.find(remark => remark.ClockType === 2) || {} // * 下班備註
      const { Note: DutyRecordNote = '' } = record.Contents.find(remark => remark.ClockType === 3) || {} // * 當日執勤紀錄
      const { Note: HandoverMattersNote = '' } = record.Contents.find(remark => remark.ClockType === 4) || {} // * 未完成事項交接
      return {
        ...record,
        ClockInImg: record.ClockImgUrl,
        ClockOutImg: record.ClockOutImgUrl,
        ClockInTime: record.ClockTime.replace(/\//g, '-'),
        ClockOutTime: record.ClockOutTime.replace(/\//g, '-'),
        ClockInRemark,
        ClockOutRemark,
        DutyRecordNote,
        HandoverMattersNote,
        isNewVersion
      }
    })
  }
}

function getScrollTop () {
  let scrollTop = 0
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop
  } else if (document.body) {
    scrollTop = document.body.scrollTop
  }
  return scrollTop
}

// 可視範圍的高度
function getClientHeight () {
  let clientHeight = 0
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
  } else {
    clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
  }
  return clientHeight
}

// 完整的高度
function getScrollHeight () {
  return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
}
</script>

<style lang="sass" scoped>
#ClockRecord
  color: $subFontColor
  +mainLayer
  ::v-deep .el-table
    +basicTable
    .el-table__row
      height: 58px
      i
        font-size: 22px
        cursor: pointer
        position: relative
        top: 4px
      .icon-images
        margin-left: 10px
      .status_green
        color: $mainColor
      .status_red
        color: $dangerColor
    .detail
      color: $mainColor
      border-bottom: 1px $mainColor solid
      cursor: pointer
    .info
      color: #999
      font-size: 22px
    .el-badge__content
      top: 11px
      background-color: $warnColorHover
      right: -5px
      border: 0
  .warning-text
    color: $dangerColor
</style>
